import { useCouponStore } from "../../store/couponStore"

export default function CouponExcelPreviewModal() {

  const excelRows = useCouponStore((s) => s.excelRows)
  const bulkUpload = useCouponStore((s) => s.bulkUpload)
  const closeExcelPreview = useCouponStore((s) => s.closeExcelPreview)

  return (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">

    <div className="bg-white w-[95vw] max-w-7xl max-h-[85vh] rounded-xl shadow-xl flex flex-col p-6">

      {/* header */}
      <div className="flex items-center justify-between px-6 py-4 border-b">

        <h2 className="text-lg font-bold text-gray-800">
          پیش‌نمایش فایل اکسل
        </h2>

        <button
          onClick={closeExcelPreview}
          className="text-gray-500 hover:text-red-500 text-xl"
        >
          ✕
        </button>

      </div>

      {/* table */}
      <div className="overflow-auto">

        <table className="min-w-[1200px] w-full text-sm text-gray-700">

          <thead className="bg-gray-100 sticky top-0 text-gray-600 text-xs">

            <tr className="text-center">

              <th className="p-3">کد یکتا</th>
              <th className="p-3">نام و نام خانوادگی</th>
              <th className="p-3">شماره موبایل</th>
              <th className="p-3">عنوان</th>
              <th className="p-3">کد</th>
              <th className="p-3">نوع تخفیف</th>
              <th className="p-3">مقدار تخفیف</th>
              <th className="p-3">حداکثر استفاده</th>
              <th className="p-3">تعداد استفاده</th>
              <th className="p-3">حداقل سفارش</th>
              <th className="p-3">حداکثر تخفیف</th>
              <th className="p-3">تاریخ انقضا</th>
              <th className="p-3">وضعیت</th>

            </tr>

          </thead>

          <tbody>

            {excelRows.map((row, i) => (
              <tr
                key={i}
                className="border-t hover:bg-gray-50 text-center"
              >

                <td className="p-3">{row.id}</td>
                <td className="p-3">{row.username}</td>
                <td className="p-3">{row.phone_number}</td>
                <td className="p-3">{row.title}</td>
                <td className="p-3 font-semibold">{row.code}</td>
                <td className="p-3">{row.discount_type}</td>
                <td className="p-3">{row.discount_value}</td>
                <td className="p-3">{row.usage_limit}</td>
                <td className="p-3">{row.usage_count}</td>
                <td className="p-3">{row.min_order_amount}</td>
                <td className="p-3">{row.max_discount_amount}</td>
                <td className="p-3">{row.expiration_date}</td>

                <td className="p-3">
                  {row.is_active ? (
                    <span className="text-green-600 font-medium">
                      فعال
                    </span>
                  ) : (
                    <span className="text-red-500 font-medium">
                      غیرفعال
                    </span>
                  )}
                </td>

              </tr>
            ))}

          </tbody>

        </table>

      </div>

      {/* footer */}
      <div className="flex justify-end gap-3 p-4 border-t bg-gray-50">

        <button
          className="px-5 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 text-gray-700"
          onClick={closeExcelPreview}
        >
          انصراف
        </button>

        <button
          onClick={bulkUpload}
          className="px-5 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white"
        >
          تایید و ثبت
        </button>

      </div>

    </div>

  </div>
)

}

